import HandIcon from 'assets/images/easyPay/init.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import DotsLoading from 'components/loadings/dotsLoading'
import BackIcon from 'assets/images/rectangle/right-green.svg'
import { MoneyPoolTransactionTypes } from '../../../utilities/helper/moneyPools'
import Switch from 'react-switch'
import useGetInitPaymentOs from 'pages/wallet/hooks/useGetInitPaymentOs'
import Footer from '../../loans/transaction/footer/index'
import { ISelectedBank } from 'utilities/hooks/useIsDefaultGateway'

export default function Transaction() {
    const [isSelected, setIsSelected] = useState<ISelectedBank>({
        saderat: false,
        parsian: true,
    })
    const [isWallet, setIsWallet] = useState<boolean>(false)
    const [payment, setPayment] = useState<number>(0)
    const [total, setTotal] = useState<number>(0)
    const [jsonData, setJsonData] = useState<any>([])
    const [lackOfWallet, setLackOfWallet] = useState<number>(0)
    const { state } = useLocation()
    const navigate = useNavigate()
    const profile = JSON.parse(localStorage.getItem('profile')!)

    return (
        <div className=" h-screen relative flex flex-col bg-main-bg">
            {true ? (
                <>
                    <div className=" my-3 px-4 grow-0">
                        <img
                            src={BackIcon}
                            alt="back"
                            onClick={() => navigate(-1)}
                        />
                    </div>
                    <div className="grow ">
                        <div className="">
                            <>
                                <div className="">
                                    <img
                                        src={HandIcon}
                                        alt="hand"
                                        className=" mx-auto -mb-24 -z-50"
                                    />
                                    <div className="  bg-white shadow-soft rounded-xl px-3 pt-3 pb-8 mx-4 mt-16 min-h-[60%] overflow-y-auto ">
                                        <div className=" flex justify-between mt-4">
                                            <p className="">مبلغ:</p>
                                            <p>تومان</p>
                                        </div>
                                        <div className=" flex justify-between mt-4">
                                            <p className=""> بابت:</p>
                                            <p>سفته</p>
                                        </div>
                                        <div className=" flex justify-between mt-4">
                                            <p className=""> در وجه:</p>
                                            <p>همیان</p>
                                        </div>
                                        <div className=" flex justify-between mt-4">
                                            <div className="text-sm">
                                                <p>استفاده از کیف پول:</p>
                                                <p className=" text-text-gray">
                                                    تومان
                                                </p>
                                            </div>
                                            <Switch
                                                onChange={() =>
                                                    setIsWallet(!isWallet)
                                                }
                                                checked={isWallet}
                                                onColor="#75B844"
                                                onHandleColor="#EAEEF0"
                                                handleDiameter={25}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                height={30}
                                                width={60}
                                                className="react-switch"
                                                id="material-switch"
                                                offColor="#B6BCC8"
                                            />
                                        </div>
                                        <hr className=" my-4" />
                                        <div className=" flex justify-between mt-4">
                                            <p className=""> مبلغ:</p>
                                            <p>تومان</p>
                                        </div>
                                    </div>

                                    <div className=" w-full items-center text-center my-4">
                                        <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                            {/* <img
                                                src={data.gateways[0].img_url}
                                                alt="bank"
                                                className={classNames(
                                                    'mx-2 cursor-pointer',
                                                    !isSelected.saderat
                                                        ? ' border-1 border-gray-4 rounded-md'
                                                        : 'border-2 border-green-1 rounded-md'
                                                )}
                                                onClick={() =>
                                                    setIsSelected({
                                                        saderat: true,
                                                        parsian: false,
                                                    })
                                                }
                                            /> */}
                                            {/* <img
                                                src={data.gateways[1].img_url}
                                                alt="bank"
                                                className={classNames(
                                                    'mx-2 cursor-pointer',
                                                    !isSelected.parsian
                                                        ? ' border-1 border-gray-4 rounded-md'
                                                        : 'border-2 border-green-1 rounded-md'
                                                )}
                                                onClick={() =>
                                                    setIsSelected({
                                                        saderat: false,
                                                        parsian: true,
                                                    })
                                                }
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                    <div className=" grow -0 w-full">
                        <Footer
                            total={Number(total)}
                            commission={2}
                            ctx_id={state?.poolShipId}
                            ctx_type="mnp"
                            destination="no"
                            gateway={isSelected.saderat ? 5 : 9}
                            isSelected={isSelected}
                            reciever={10}
                            role={state?.role}
                            lackOfWallet={lackOfWallet}
                            isWallet={isWallet}
                            memberId={profile?.id}
                            payment={payment}
                            jsonData={jsonData}
                        />
                    </div>
                </>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
